/* global grecaptcha */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { siteKey: String };

  initialize() {
    grecaptcha.render(this.element, { sitekey: this.siteKeyValue });
  }
}
